"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ValidationResult_1 = require("./ValidationResult");

var ValueDesc_1 = require("./ValueDesc");

var OptionalDesc =
/*#__PURE__*/
function (_ValueDesc_1$ValueDes) {
  _inherits(OptionalDesc, _ValueDesc_1$ValueDes);

  function OptionalDesc(desc, base) {
    var _this;

    _classCallCheck(this, OptionalDesc);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(OptionalDesc).call(this, desc));
    _this.base = base;
    return _this;
  }

  _createClass(OptionalDesc, [{
    key: "validate",
    value: function validate(input, level) {
      if (input === null || input === undefined) {
        return new ValidationResult_1.ValidationSuccess(null);
      }

      return this.base.validate(input, level);
    }
  }, {
    key: "withDescription",
    value: function withDescription(descr) {
      return new OptionalDesc(this.mergeDescs(descr), this.base);
    }
  }, {
    key: "acceptVisitor",
    value: function acceptVisitor(visitor) {
      return visitor.visitOption(this);
    }
  }]);

  return OptionalDesc;
}(ValueDesc_1.ValueDesc);

exports.OptionalDesc = OptionalDesc;